import { t } from "i18next";
import React from "react";

const OrderStarRating = ({ totalStars, handleStarClick, rating }) => {
  const starElements = [...Array(totalStars)].map((_, index) => (
    <span
      key={index}
      style={{ fontSize: "50px" }}
      className={index < rating ? "star selected" : "star"}
      onClick={() => handleStarClick(index + 1)}
    >
      ★
    </span>
  ));

  return (
    <div className="horizontal-star-rating cursor-pointer">{starElements}</div>
  );
};

const StarRating = ({ rating, maxStars = 5,maxRating = 5, reviewsCount,  }) => {
  const getFillPercent = (index) => {
    const fillPerStar = maxRating / maxStars; 
    const valueForThisStar = (index + 1) * fillPerStar;
    const fill = Math.min(Math.max(rating - (valueForThisStar - fillPerStar), 0), fillPerStar);
    return (fill / fillPerStar) * 100;
  };

  return (
    <div className="flex items-center space-x-1 ">
      {Array.from({ length: maxStars }).map((_, index) => {
        const fillPercent = getFillPercent(index);

        return (
          <svg
            key={index}
            className="w-4 h-4"
            viewBox="0 0 20 20"
            fill="currentColor"
            style={{marginBottom:"5px"}}
          >
            <defs>
              <linearGradient id={`grad-${index}`}>
                <stop
                  offset={`${fillPercent}%`}
                  stopColor="#F97316" /* Tailwind orange-500 */
                />
                <stop
                  offset={`${fillPercent}%`}
                  stopColor="#D1D5DB" /* Tailwind gray-300 */
                />
              </linearGradient>
            </defs>
            <path
              fill={`url(#grad-${index})`}
              d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.955a1 1 0 00.95.69h4.163c.969 0 
              1.371 1.24.588 1.81l-3.37 2.448a1 1 0 00-.364 1.118l1.287 3.955c.3.921-.755 
              1.688-1.54 1.118l-3.37-2.448a1 1 0 00-1.175 0l-3.37 2.448c-.785.57-1.84-.197-1.54-1.118l1.287-3.955a1 
              1 0 00-.364-1.118L2.07 9.382c-.783-.57-.38-1.81.588-1.81h4.163a1 1 
              0 00.95-.69l1.286-3.955z"
            />
          </svg>
        );
      })}
       <span className="ml-1 text-13x text-orange font-semibold">{rating}</span>
       {reviewsCount && reviewsCount >0 && <span className="text-13x text-shadow-forge-700 font-normal">( {t(reviewsCount)+"+ reviews"} )</span>}
    </div>
  );
};
export {StarRating}

export default OrderStarRating;
